import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, fmtError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/reset-password", { token: params.get("token") || "", password });
      setDone(true);
      setTimeout(() => navigate("/login"), 1500);
    } catch (err) {
      setError(fmtError(err));
    }
  };

  return (
    <div className="min-h-screen bg-teca-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-card rounded-2xl p-6 shadow-2xl" data-testid="reset-form">
        <h1 className="font-display text-2xl font-bold uppercase mb-4">Nouveau mot de passe</h1>
        {done ? (
          <p data-testid="reset-confirmation" className="text-sm text-emerald-700 font-semibold">Mot de passe réinitialisé. Redirection…</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <Input data-testid="reset-password-input" type="password" required minLength={6} value={password}
              onChange={(e) => setPassword(e.target.value)} placeholder="Nouveau mot de passe" className="py-3.5" />
            {error && <div data-testid="reset-error" className="text-sm text-red-600">{error}</div>}
            <Button data-testid="reset-submit" type="submit" className="w-full h-13 bg-amber-500 text-slate-900 font-bold hover:bg-amber-400">RÉINITIALISER</Button>
          </form>
        )}
        <Link to="/login" className="block text-center text-sm text-amber-600 font-semibold mt-4 hover:underline">Retour à la connexion</Link>
      </div>
    </div>
  );
}
